module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_White-8ea892032dd7d18b3ad63760b307b3ef.svg";